/**
 * AssetRelationshipGraph Component
 *
 * Displays a graph visualization of asset relationships including parent and child assets.
 * Renders the AssetsGraph component showing the hierarchical structure of asset connections.
 */

import { AssetsGraph } from '@/sections/asset/components/tabs';
import { Asset } from '@/types';

export interface AssetRelationshipGraphProps {
  processedParentAssets: Asset[];
  processedChildAssets: Asset[];
  asset: Asset;
}

export function AssetRelationshipGraph({
  processedParentAssets,
  processedChildAssets,
  asset,
}: AssetRelationshipGraphProps) {
  return (
    <div className="border-chariot-stroke h-72 min-h-72 w-full overflow-hidden rounded-md border">
      <AssetsGraph
        child={processedChildAssets}
        parent={processedParentAssets}
        asset={asset}
      />
    </div>
  );
}
